import api from '../hooks/useHttp';

/**
 * Base API service class with common CRUD operations
 */
class ApiService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  // GET request
  async get(endpoint = '', params = {}) {
    const response = await api.get(`${this.baseUrl}${endpoint}`, { params });
    return response;
  }

  // POST request
  async create(data, endpoint = '') {
    const response = await api.post(`${this.baseUrl}${endpoint}`, data);
    return response;
  }

  // PUT request
  async update(id, data, endpoint = '') {
    const response = await api.put(`${this.baseUrl}${endpoint}/${id}`, data);
    return response;
  }

  // PATCH request
  async partialUpdate(id, data, endpoint = '') {
    const response = await api.patch(`${this.baseUrl}${endpoint}/${id}`, data);
    return response;
  }

  // DELETE request
  async delete(id, endpoint = '') {
    const response = await api.delete(`${this.baseUrl}${endpoint}/${id}`);
    return response;
  }

  // Upload file
  async upload(formData, endpoint = '') {
    const response = await api.upload(`${this.baseUrl}${endpoint}`, formData);
    return response;
  }
}

export default ApiService;

